import React from 'react';
import Helmet from 'react-helmet';

class HomeIndex extends React.Component {
    render() {
        const siteTitle = this.props.data.site.siteMetadata.title;
        const siteDescription = this.props.data.site.siteMetadata.description;

        return (
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                </Helmet>
                <div id="main">
                    <section id="one">
                        <header className="major">
                            <h2>MyTruck.net</h2>
                        </header>
                        <p>
                            I purchased this domain name 20 years ago and have used it on and off
                            over the years for trucks I have owned. At this point, I have not used
                            it in quite some time now, so I am putting it up for sale. In my
                            opinion, it is a premium domain name for a commercial or community site
                            for trucks or auto/truck parts.
                        </p>
                    </section>
                    <section id="two">
                        <h2>Get In Touch</h2>
                        <p>
                            Please <a href="mailto:frank@undiscoveredsoftware.com">email me</a> if
                            you are interested in purchasing it.
                        </p>
                    </section>
                </div>
            </div>
        );
    }
}

export default HomeIndex;

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js